<template>
  <b-card-actions action-collapse title="Liste des devis">
    <div class="custom-search">
      <!-- advance search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <!-- <label class="mr-1">Recherche</label> -->
            <b-form-input
              placeholder="Recherche"
              type="text"
              class="d-inline-block"
              @input="advanceSearch"
            />
            <b-button
              variant="gradient-danger"
              class="btn-icon btn-delete-all"
              @click="deleteAllQuote()"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </b-form-group>
      </div>
    </div>

    <!-- table -->
    <!-- :rtl="direction" -->
    <vue-good-table
                ref="table-quote"

      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      theme="my-theme"
    >
      <template slot="table-row" slot-scope="props" class="table-added-element">
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
                <b-dropdown-item
                v-b-modal.modal-product
                @click="productQuote(props.row)"
              >
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span>Détails Produits</span>
              </b-dropdown-item>
              <b-dropdown-item @click="previewQuote(props.row._id)">
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span>Consulter Devis</span>
              </b-dropdown-item>

              <b-dropdown-item @click="createCommand(props.row)">
                <feather-icon icon="FileTextIcon" class="mr-50" />
                <span>Créer commande</span>
              </b-dropdown-item>
              <b-dropdown-item @click="createInvoice(props.row)">
                <feather-icon icon="FilePlusIcon" class="mr-50" />
                <span>Créer facture</span>
              </b-dropdown-item>
                          <b-dropdown-item @click="UpdateQuote(props.row._id)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Modifier</span>
              </b-dropdown-item>
              <b-dropdown-item @click="DeleteQuote(props.row._id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Supprimer</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <span v-else-if="props.column.field == 'images'" class="dflex">
          <a
            v-for="(image, index) in props.row.images"
            :key="index"
            :href="imgFormat(image)"
            target="_blank"
            class="mlr10"
          >
            <b-img :src="imgFormat(image)" class="img-table"
          /></a>
        </span>
        <span v-else-if="props.column.field == 'description'">
          <p class="p-description">{{ props.row.description }}</p>
        </span>

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Afficher 1 à </span>
            <b-form-select
              v-model="pageLength"
              :options="['5', '10', '15']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> sur {{ props.total }} résultats </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <b-modal
      v-model="show"
      id="modal-product"
      cancel-variant="outline-secondary"
      ok-title="Product"
      cancel-title="Close"
      centered
      size="lg"
      title="Liste des produits"
    >
      <vue-good-table
        :columns="columnsModal"
        :rows="rowModal"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLengthModal,
        }"
        theme="my-theme"
      >
        <template
          slot="table-row"
          slot-scope="propsModal"
          class="table-added-element"
        >
          <span
            v-if="propsModal.column.field == 'product.priceWithoutTaxes'"
            class="dflex"
          >
            {{ priceFormat(propsModal.row.discount) }}
          </span>
          <span v-else-if="propsModal.column.field == 'discount'" class="dflex">
            {{ propsModal.row.discount + "%" }}
          </span>
          <span
            v-else-if="propsModal.column.field == 'valueAddedTax'"
            class="dflex"
          >
            {{ propsModal.row.valueAddedTax + "%" }}
          </span>
          <span v-else>
            {{ propsModal.formattedRow[propsModal.column.field] }}
          </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Afficher 1 à </span>
              <b-form-select
                v-model="pageLengthModal"
                :options="['3', '5', '10']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> sur {{ props.total }} résultats </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLengthModal"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="danger"
            size="md"
            @click="show = false"
          >
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-card-actions>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BRow,
  BCol,
  BImg,
  BModal,
  VBModal,
  BForm,
  BDropdown,
  BDropdownItem,
  BTooltip,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import axios from "axios";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BTooltip,
    BModal,
    VBModal,
    BForm,
    BImg,
    BButton,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      show: false,
      pageLength: 5,
      pageLengthModal: 5,
      dir: false,
      columnsModal: [
        {
          label: "Label",
          field: "product.label",
          filterOptions: {
            enabled: true,
            placeholder: "Label",
          },
        },
        {
          label: "Quantité",
          field: "quantity",
          filterOptions: {
            enabled: true,
            placeholder: "Quantié",
          },
        },
        {
          label: "Prix unité hors tax",
          field: "product.priceWithoutTaxes",
          filterOptions: {
            enabled: true,
            placeholder: "Prix sans tax",
          },
        },
        {
          label: "Remise",
          field: "discount",
          filterOptions: {
            enabled: true,
            placeholder: "Remise",
          },
        },
        {
          label: "Tax",
          field: "valueAddedTax",
          filterOptions: {
            enabled: true,
            placeholder: "Tax",
          },
        },
      ],
      columns: [
         {
          label: "Action",
          field: "action",
          sortable: false,
        },
        {
          label: "Code",
          field: "code",
          filterOptions: {
            enabled: true,
            placeholder: "Code",
          },
        },
        {
          label: "État",
          field: "status",
          filterOptions: {
            enabled: true,
            placeholder: "État",
          },
        },
        {
          label: "Client",
          field: "customer",
          formatFn: this.customerFormat,
          filterOptions: {
            enabled: true,
            placeholder: "Client",
          },
        },
        {
          label: "Entrepôt",
          field: "warehouse",
          filterOptions: {
            enabled: true,
            placeholder: "Entrepôt",
          },
        },
        {
          label: "Date de livraison",
          field: "date",
          formatFn: this.dateFormat,
          filterOptions: {
            enabled: true,
            placeholder: "Date de livraison",
          },
        },
        {
          label: "Description",
          field: "description",
          filterOptions: {
            enabled: true,
            placeholder: "Description",
          },
        },

        {
          label: "Timbre",
          field: "stampPrice",

          filterOptions: {
            enabled: true,
            placeholder: "Timbre",
          },
        },
        {
          label: "Tax (%)",
          field: "valueAddedTax",
          filterOptions: {
            enabled: true,
            placeholder: "Tax",
          },
        },

        {
          label: "Remise (%)",
          field: "totalDiscount",
          filterOptions: {
            enabled: true,
            placeholder: "Remise",
          },
        },
        {
          label: "Totale TTC",
          field: "allTaxesIncluded",
          filterOptions: {
            enabled: true,
            placeholder: "Totale",
          },
        },
        {
          label: "Date d'insertion",
          field: "createdAt",
          filterOptions: {
            enabled: true,
            placeholder: "Date d'insertion",
          },
          formatFn: this.dateFormat,
        },
        {
          label: "Agent de saisie",
          field: "createdBy",
          filterOptions: {
            enabled: true,
            placeholder: "Agent de saisie",
          },
          formatFn: this.createdByFormat,
        },
        {
          label: "Date de modification",
          field: "updatedAt",
          filterOptions: {
            enabled: true,
            placeholder: "Date de modification",
          },
          formatFn: this.dateFormat,
        },
        {
          label: "Images",
          field: "images",
          sortable: false,
          width: "150px",
          // html: true,
        },
       
      ],
      rows: [],
      rowModal: [],
      searchTerm: "",
    };
  },
  async created() {
    await this.getAllDataQuote();
  },
  methods: {


    advanceSearch(val) {
      this.searchTerm = val;
    },
    // Start To => utils************************************************
    priceFormat(price) {
       if(price){
        return Number.parseFloat(price).toFixed(3);
      }
    },
    imgFormat: function (value) {
      if (value) {
        return (
          "https://res.cloudinary.com/dmdd546ps/image/upload/v1615691410/" +
          value +
          ".png"
        );
      }
    },
    //date format
    dateFormat: function (value) {
      return new Date(value).toLocaleString();
    },
    // table Format
    tableFormat: function (value) {
      const table = value.map((element) => {
        return element.label;
      });
      return table.toString();
    },
    // name agent de saisie
    createdByFormat: function (value) {
      return value.firstName + " " + value.lastName;
    },
    customerFormat: function (value) {
      return value.firstName + " " + value.lastName;
    },
    // End To => utils************************************************

    async getAllDataQuote() {
   if( this.$router.history.current.query.prospect){
       const response = await axios
        .get("https://management-projects.herokuapp.com/api/sales-quotations?prospect="+this.$router.history.current.query.prospect)
        .then((response) => {
          console.log(response);
          this.rows = response.data;
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
      }else if( this.$router.history.current.query.customer){
       const response = await axios
        .get("https://management-projects.herokuapp.com/api/sales-quotations?customer="+this.$router.history.current.query.customer)
        .then((response) => {
          console.log(response);
          this.rows = response.data;
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
      }else{
       const response = await axios
        .get("https://management-projects.herokuapp.com/api/sales-quotations")
        .then((response) => {
          console.log(response);
          this.rows = response.data;
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
      }


    },
      deleteAllQuote() {
      var deleteIds = [];
      this.$refs["table-quote"].selectedRows.forEach((element) => {
        deleteIds.push(element._id);
      });
      axios
        .delete(
          `https://management-projects.herokuapp.com/api/sales-quotations?ids=${deleteIds.join(
            ","
          )}&deletedBy=${JSON.parse(localStorage.getItem("userData"))._id}`
        )
        .then((response) => {
          this.getAllDataQuote();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Devis bien supprimé`,
              icon: "UserIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Erreur lors de la suppression`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
          console.log(this.errorMessage);
        });
    },
    DeleteQuote(id) {
      this.$swal({
        title: "vous voulez vraiment supprimer cette Devis ?",
        text: "Vous ne pourrez pas annuler cela!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmer !",
        cancelButtonText: "Annuler !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          var payload = {
            deletedBy: JSON.parse(localStorage.getItem("userData"))._id,
          };
          axios
            .delete(
              `https://management-projects.herokuapp.com/api/sales-quotations?ids=${id}&deletedBy=${
                JSON.parse(localStorage.getItem("userData"))._id
              }`
            )
            .then((response) => {
              this.getAllDataQuote();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Devis bien supprimé`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Erreur lors de la suppression`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
              console.log(this.errorMessage);
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action annulée",
            icon: "error",
            confirmButtonText: "Fermer !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    productQuote(data) {
      console.log(data);
      this.rowModal = data.products;
    },
    UpdateQuote(id) {
      var routerLink = "/sale/quote/edit-quote?id=" + id;
      this.$router.replace(routerLink);
    },
    previewQuote(id) {
      var routerLink = "/sale/quote/preview-quote?id=" + id;
      this.$router.replace(routerLink);
    },
    createCommand(data) {
      this.$swal({
        title: "vous voulez vraiment créer une commande ?",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Confirmer !",
        cancelButtonText: "Annuler !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          var productsToSend=[]
          data.products.forEach(element => {
            productsToSend.push({
              description: element.description,
              discount: element.discount,
              product:element.product._id,
              quantity:element.quantity,
              quantityType:element.quantityType,
              valueAddedTax: element.valueAddedTax
            })
          });
          var payload = {
            code:data.code,
            createdBy: (JSON.parse(localStorage.getItem("userData"))._id),
            allTaxesIncluded: data.allTaxesIncluded,
            priceWithoutTaxes:data.priceWithoutTaxes,
            customer: data.customer._id,
            deliveryDate: data.deliveryDate,
            description: data.description,
            priceWithoutTaxes: data.priceWithoutTaxes,
            products: productsToSend,
            stampPrice: data.stampPrice,
            totalDiscount: data.totalDiscount,
            valueAddedTax: data.valueAddedTax,
            warehouse: data.warehouse,
            salesBills: data._id,
            currency:data.currency
          };
          console.log("payload",JSON.stringify(payload),data);
          axios
            .post(
              "https://management-projects.herokuapp.com/api/sales-commands",
              payload
            )
            .then((response) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Commande bien ajoutée`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Erreur lors de l'ajout`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
              console.log(this.errorMessage);
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action annulée",
            icon: "error",
            confirmButtonText: "Fermer !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    createInvoice(data) {
      this.$swal({
        title: "vous voulez vraiment créer une facture ?",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Confirmer !",
        cancelButtonText: "Annuler !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
       var productsToSend=[]
          data.products.forEach(element => {
            productsToSend.push({
              description: element.description,
              discount: element.discount,
              product:element.product._id,
              quantity:element.quantity,
              quantityType:element.quantityType,
              valueAddedTax: element.valueAddedTax
            })
          });
          var payload = {
            code:data.code,
            createdBy: (JSON.parse(localStorage.getItem("userData"))._id),
            allTaxesIncluded: data.allTaxesIncluded,
            priceWithoutTaxes:data.priceWithoutTaxes,
            customer: data.customer._id,
            deliveryDate: data.deliveryDate,
            description: data.description,
            priceWithoutTaxes: data.priceWithoutTaxes,
            products: productsToSend,
            stampPrice: data.stampPrice,
            totalDiscount: data.totalDiscount,
            valueAddedTax: data.valueAddedTax,
            warehouse: data.warehouse,
            salesBills: data._id,
            currency:data.currency
          };
          console.log(payload);
          axios
            .post(
              "https://management-projects.herokuapp.com/api/sales-bills",
              payload
            )
            .then((response) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `facture bien ajoutée`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Erreur lors de l'ajout`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
              console.log(this.errorMessage);
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action annulée",
            icon: "error",
            confirmButtonText: "Fermer !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style>
.btn-action-table button {
  margin-left: 10px;
  margin-top: 5px;
}
.btn-action-table {
  display: flex;
}
.btn-delete-all {
  margin-left: 3%;
}

.p-description {
  height: 60px;
  width: 250px;
  overflow: auto;
}
.barcode-size svg {
  height: 80px;
}
</style>
